import { render, staticRenderFns } from "./RootDashboard.vue?vue&type=template&id=35b74cc7&scoped=true"
import script from "./RootDashboard.vue?vue&type=script&lang=js"
export * from "./RootDashboard.vue?vue&type=script&lang=js"
import style0 from "./RootDashboard.vue?vue&type=style&index=0&id=35b74cc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b74cc7",
  null
  
)

export default component.exports